import { takeLatest, call, put, all } from "redux-saga/effects"

import axios from "axios"
import { message } from "antd"

import { values, flatMap } from "lodash"

import { push } from "connected-react-router"
import {
  GET_COLLABORATOR_INFO_WATCHER,
  UPDATE_COLLABORATOR_WATCHER,
  REMOVE_COLLABORATOR_WATCHER,
  GET_MEASURES_WATCHER,
  GET_LANGUAGE_WATCHER,
} from "./constants"

import {
  updateCollaboratorEnd,
  getCollaboratorSuccess,
  getMeasuresSuccess,
  getMeasuresFailed,
  getLanguageSuccess,
  getLanguageFailed,
} from "./actions"
import { editCollaboratorSegment } from "../../utils/segment/Employee/employeeTrack"
// Individual exports for testing
import {
  getDivisionsApi,
  getCurrencyApi,
  getCategoriesApi,
  getGendersApi,
} from "../CollaboratorsCreate/saga"

import { removeCollaboratorsApi } from "../Collaborators/saga"
import { LOCAL_TOKEN } from "../../utils/storage"

// GET LANGUAGE
export function getLanguageApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}language/`,
  })
}
export function* getLanguageSaga() {
  try {
    const {
      data: { data },
    } = yield call(getLanguageApi)

    yield put(getLanguageSuccess(data))
  } catch (error) {
    yield put(getLanguageFailed())
    returnMessage(error)
  }
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

export function updateCollaboratorsApi(payload) {
  return axios.request({
    method: "PUT",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${payload.id}`,
    data: payload.params,
  })
}

export function getCollaboratorApi(id) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${id}?relation=activepositions`,
  })
}

export function* updateCollaboratorSaga(action) {
  try {
    const data = yield call(updateCollaboratorsApi, action.payload)
    editCollaboratorSegment(
      action.payload.params,
      action.payload.infoEditSegment
    )
    messageSuccess("Los cambios han sido guardados")
    yield put(updateCollaboratorEnd())
    yield put(push("/organization#collaborators"))
  } catch (e) {
    yield put(updateCollaboratorEnd())
    returnMessage(e)
    // const { response: { data } } = JSON.parse(JSON.stringify(e))
    // if (typeof data.data.error == 'string') {
    //   messageFailed(data.data.error)
    // } else {
    //   let array = flatMap(values(data.data.error), item => item);
    //   messageFailed(array[0])
    // }
    // array.forEach(function (item) {
    //   // yield call(messageFailed, item)
    //   messageFailed(item)
    // })
  }
}

export function getLeadersApi(id) {
  return axios.request({
    method: "get",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${id}/teamleader/potential`,
  })
}

export function getLocationsApi() {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}segment-variables/groups/7`,
  })
}

export function* getCollaboratorsDataSaga(action) {
  try {
    const [
      collaborator,
      divisions,
      currency,
      categories,
      leaders,
      genders,
      locations,
    ] = yield all([
      call(getCollaboratorApi, action.payload),
      call(getDivisionsApi),
      call(getCurrencyApi),
      call(getCategoriesApi),
      call(getLeadersApi, action.payload),
      call(getGendersApi),
      call(getLocationsApi),
    ])

    const payload = {
      collaborator: collaborator.data.data,
      divisions: divisions.data.data,
      currency: currency.data.data,
      categories: categories.data.data,
      leaders: leaders.data.data,
      genders: genders.data.data,
      locations: locations.data.data,
    }

    yield put(getCollaboratorSuccess(payload))
  } catch (error) {
    returnMessage(error)
  }
}

export function* removeCollaboratorSaga(action) {
  try {
    const data = yield call(removeCollaboratorsApi, action.payload)
    messageSuccess("Colaborador eliminado con éxito")
    yield put(push("/organization#collaborators"))
  } catch (error) {
    messageFailed("Error al eliminar colaborador")
  }
}

// GET MEASURES
export function getMeasuresApi(payload) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${process.env.API_URL}employees/${payload}/measures`,
  })
}

export function* getMeasuresSaga(action) {
  try {
    const { data, status } = yield call(getMeasuresApi, action.payload)

    if (status === 200) {
      yield put(getMeasuresSuccess(data.data))
    }
  } catch (e) {
    yield put(getMeasuresFailed())
  }
}

export default function* collaboratorsEditSaga() {
  yield takeLatest(GET_COLLABORATOR_INFO_WATCHER, getCollaboratorsDataSaga)
  yield takeLatest(UPDATE_COLLABORATOR_WATCHER, updateCollaboratorSaga)
  yield takeLatest(REMOVE_COLLABORATOR_WATCHER, removeCollaboratorSaga)
  yield takeLatest(GET_MEASURES_WATCHER, getMeasuresSaga)
  yield takeLatest(GET_LANGUAGE_WATCHER, getLanguageSaga)
}
